import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getExtraPayments = actionFactory(types.GET_EXTRA_PAYMENTS);
export const deleteExtraPayments = actionFactory(types.DELETE_EXTRA_PAYMENT);
export const updateExtraPayments = actionFactory(types.UPDATE_EXTRA_PAYMENT);
export const approveExtraPayment = actionFactory(types.APPROVE_EXTRA_PAYMENT);
export const declineExtraPayment = actionFactory(types.DECLINE_EXTRA_PAYMENT);
